// export function initDatepicker() {
// 	$('.date, .date_int').datepicker({
// 		dateFormat: 'yy-mm-dd',
// 		onSelect: function() {
// 			$(this)[0].dispatchEvent(new Event('input', { bubbles: true }));
// 		},
// 	});
// }

// 공용 날짜 함수는 저장소 루트의 shared/utils/date.js 한 곳에만 둔다.
// 이 파일은 재수출 shim 이므로 기존 '@/utils/date' import 는 그대로 동작한다.
// 아래 desktop 전용 함수가 공용 toText·toDate·isDate 를 호출하므로 재수출과 별도로 import binding 도 만든다.
import { isDate, toDate, toText } from '@shared/utils/date';
import moment from 'moment-timezone';

export { toText, toDate, isDate, normalizeOptionalMdyDate, isValidOptionalMdyDate, today, nextWorkingDay, daysAgo, dateDiff, compareDate, dateStrDiff } from '@shared/utils/date';

// 아래는 desktop(vue) 전용 함수다. mobile 에서 쓰게 되면 shared 로 옮긴다.

// Invoice audit timestamps are UTC; keep the original microsecond token untouched.
export function formatEasternTime(value) {
	if (!value) return '';
	const timestamp = moment.utc(value, 'YYYY-MM-DD HH:mm:ss.SSSSSS', true);
	return timestamp.isValid() ? timestamp.tz('America/New_York').format('MM-DD-YYYY HH:mm:ss z') : '';
}

export function convertYMDToMDY(str_date, delim) {
	if (!str_date) return null;

	const rxDatePattern = /^(\d{4})(\/|-)(\d{2})(\/|-)(\d{2})$/; //Declare Regex // yyyy-mm-dd
	const dtArray = str_date.match(rxDatePattern); // is format OK?
	// console.log(dtArray); /* ['2022-04-26', '2022', '-', '04', '-', '26', index: 0, input: '2022-04-26', groups: undefined] */
	if (dtArray == null) return str_date;
	if (!delim) delim = '-';

	return dtArray[3] + delim + dtArray[5] + delim + dtArray[1];
}

export function convertMDYToYMD(str_date, delim) {
	if (!str_date) return null;

	const rxDatePattern = /^(\d{2})(\/|-)(\d{2})(\/|-)(\d{4})$/; //Declare Regex // mm-dd-yyyy
	const dtArray = str_date.match(rxDatePattern); // is format OK?
	// console.log(dtArray);
	if (dtArray == null) return str_date;
	if (!delim) delim = '-';

	return dtArray[5] + delim + dtArray[1] + delim + dtArray[3];
}

export function convertYMDToMMDDYY(date_str, delim) {
	// date_str : YYYY-MM-DD
	if (!date_str) return '';
	if (!delim) delim = '-';

	const arr = convertYMDToMDY(date_str, delim).split(delim);
	arr[arr.length - 1] = arr[arr.length - 1].substr(2, 4);
	return arr.join(delim);
}

export function convertMDYToMMDDYY(date_str, delim) {
	// date_str : MM-DD-YYYY
	if (!date_str) return '';
	if (!delim) delim = '-';

	const arr = date_str.split('-');
	arr[arr.length - 1] = arr[arr.length - 1].substr(2, 4);
	return arr.join(delim);
}

export function toTextByFormat(d, format) {
	// YYYY, MM, DD, HH, mm, ss
	const yyyy = d.getFullYear();
	let mm = d.getMonth() + 1; // getMonth() is zero-based
	if (mm < 10) mm = '0' + mm;
	let dd = d.getDate();
	if (dd < 10) dd = '0' + dd;
	let hour = d.getHours();
	if (hour < 10) hour = '0' + hour;
	let min = d.getMinutes();
	if (min < 10) min = '0' + min;
	let sec = d.getSeconds();
	if (sec < 10) sec = '0' + sec;

	format = format.replace('YYYY', yyyy);
	format = format.replace('MM', mm);
	format = format.replace('DD', dd);
	format = format.replace('HH', hour);
	format = format.replace('mm', min);
	format = format.replace('ss', sec);

	return format;
}

export function toTextYMD(d, delim) {
	if (!delim) delim = '-';

	let yyyy = d.getFullYear();
	let mm = d.getMonth() + 1;
	if (mm < 10) mm = '0' + mm;

	let dd = d.getDate();
	if (dd < 10) dd = '0' + dd;

	return yyyy + delim + mm + delim + dd;
}

export function isInThePast(date_str) {
	const today = new Date();
	today.setHours(0, 0, 0, 0);

	return toDate(date_str) < today;
}

export function daysAdd(days) {
	var d = new Date();
	d.setDate(d.getDate() + days);
	return toText(d, '-');
}

export function monthAdd(month) {
	let d = new Date();
	d.setMonth(d.getMonth() + month);
	return toText(d, '-');
}

export function lastWorkingDay() {
	let d = new Date();
	d.setDate(d.getDate() - 1); // tomorrow
	if (d.getDay() === 0) d.setDate(d.getDate() - 2);
	else if (d.getDay() === 6) d.setDate(d.getDate() - 1);

	return toText(d, '-');
}

export function toYear() {
	return new Date().getUTCFullYear();
}

export function toMonthYearText(yearsAgo = 0) {
	const d = new Date();
	d.setFullYear(d.getFullYear() - yearsAgo);
	const yyyy = d.getFullYear();
	let mm = d.getMonth() + 1; // getMonth() is zero-based
	if (mm < 10) mm = '0' + mm;
	return `${mm}-${yyyy}`;
}

export function calcDate(txtDate, days) {
	// MM-dd-yyyy
	if (!(txtDate && isDate(txtDate) && typeof days === 'number')) return txtDate;

	let dtArray = txtDate.split('-');
	let calcD = new Date(Number(dtArray[2]), Number(dtArray[0]) - 1, Number(dtArray[1]) + days);
	return (calcD.getMonth() + 1 < 10 ? '0' : '') + (calcD.getMonth() + 1) + (calcD.getDate() < 10 ? '-0' : '-') + calcD.getDate() + '-' + calcD.getFullYear();
}

/**
 * 두 날짜 사이의 만(滿) 년수 차이를 계산합니다.
 * @param {Date} dateFrom - 시작 날짜 (Date 객체)
 * @param {Date} dateTo - 종료 날짜 (Date 객체)
 * @returns {number} 만 년수 차이
 */
export function yearDiff(dateFrom, dateTo) {
	if (!(dateFrom instanceof Date) || !(dateTo instanceof Date)) {
		return NaN; // 유효하지 않은 Date 객체일 경우 NaN 반환
	}

	let yearDifference = dateTo.getFullYear() - dateFrom.getFullYear();
	const monthDifference = dateTo.getMonth() - dateFrom.getMonth();
	const dayDifference = dateTo.getDate() - dateFrom.getDate();

	// date_to의 월/일이 date_from의 월/일보다 이전이면, 아직 1년이 채워지지 않은 것입니다.
	if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
		yearDifference--;
	}

	return yearDifference;
}

export function getDayOfWeek(date) {
	if (!(date instanceof Date)) return null;

	const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
	return days[date.getDay()];
}

export function getDayByMySQLDayOfWeek(day_of_week) {
	// 1 ~ 7: SUN ~ SAT
	if (typeof day_of_week !== 'number') return null;
	if (day_of_week < 1 || day_of_week > 7) return null;

	return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'][day_of_week - 1];
}

export function convertMinToHour(min) {
	if (typeof min !== 'number') return min;
	return Math.floor(min / 60) + 'h ' + (min % 60) + 'm';
}
